export default __webpack_public_path__ + "static/media/sc2.29648e87.png";